import boardsService from '../services/boardsService';

export const fetchAllBoards = async () => {
  const result = await boardsService.getAllBoards();
  if (!result?.success) {
    const error = new Error(result?.message || 'Kurullar alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchBoardById = async (id) => {
  const result = await boardsService.getBoardById(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Kurul bilgisi alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const createBoard = async (payload) => {
  const result = await boardsService.createBoard(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Kurul oluşturulamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const updateBoard = async (payload) => {
  const result = await boardsService.updateBoard(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Kurul güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const deleteBoard = async (id) => {
  const result = await boardsService.deleteBoard(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Kurul silinemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const reorderBoards = async ({ boardIdsInOrder }) => {
  const result = await boardsService.reorderBoards({ boardIdsInOrder });
  if (!result?.success) {
    const error = new Error(result?.message || 'Sıralama güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export default {
  fetchAllBoards,
  fetchBoardById,
  createBoard,
  updateBoard,
  deleteBoard,
  reorderBoards,
};


